import React from 'react';
import { useFormikContext } from 'formik';
import { P } from '@futurefamily/ef-components';
import { treatments } from 'constants/treatments';

function TreatmentDescription (props) {
  const { values } = useFormikContext();
  if (!values.treatment) { return null; }

  const treatment = treatments.find(({ value }) => value === values.treatment);

  if (!treatment) { return null; }

  return (
    <P {...props}>{treatment.description}</P>
  );
}

export default TreatmentDescription;